import React, { useEffect, useState, useMemo } from "react";
import SectionHeader from "../../components/sectionHeader/sectionHeader";
import Card from "../../components/card/card";
import { getApiInstance } from "../../utils/api";
import InputSearch from "../../components/inputs/inputSearch/inputSearch";
import "./dotacionesFijas.scss";
import { useParams, useSearchParams } from "react-router-dom";
import Button from "../../components/button/button";
import { IoReloadOutline } from "react-icons/io5";
import { searchByKeywords } from "../../utils/searchUtils";
import { formatCategories, getCategorySlug } from "../../utils/categoryUtils";


export default function DotacionesFijas() {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [searchParams, setSearchParams] = useSearchParams();
    const [searchTerm, setSearchTerm] = useState("");
    const { subcategoria } = useParams();
    const [visibleCount, setVisibleCount] = useState(15);
    const [allProducts, setAllProducts] = useState([]);
    const [allGlobal, setAllGlobal] = useState(null);
    const [, setLoadingGlobal] = useState(false);

    useEffect(() => {
    const term = searchParams.get("q") || "";
    setSearchTerm(term);
}, [searchParams]);


useEffect(() => {
  const loadAll = async () => {
    if (!searchTerm || allGlobal) return; // ya cargado o no hace falta
    try {
      setLoadingGlobal(true);
      const api = getApiInstance();
      const res = await api.get('/api/Mueble/GetMueblesCatalogo');
      setAllGlobal(res.data);
    } catch (e) {
      console.error('Error cargando catálogo global', e);
    } finally {
      setLoadingGlobal(false);
    }
  };
  loadAll();
}, [searchTerm, allGlobal]);

    const subcategoriaTitleMap = {
        miami: "Miami-Splau",
        "make-up-400-plus": "Make Up 400 PLUS",
    };

    const subcategoriaTitle = subcategoria
        ? subcategoriaTitleMap[subcategoria.toLowerCase()] || subcategoria
        : "Todo";

        useEffect(() => {
        fetchProducts(subcategoria);
    }, [subcategoria]);

const fetchProducts = async (subcategoriaKey) => {
    setLoading(true);
    const api = getApiInstance();

    try {
        const response = await api.get("/api/Mueble/GetMueblesCatalogo");

        // 1. Filtrar muebles con unidades fijas o descripción de dotación fija
        const withFixedUnits = response.data.filter((product) => {
            const units = Number(product.unidadesFijas);
            const hasUnits = !isNaN(units) && units > 0;
            const hasFixedUnitsDescription =
                product.descripcionUnidadesFijas?.trim();

            return hasUnits || hasFixedUnitsDescription;
        });

        // 2. Guardamos todos los productos válidos para búsquedas globales
        setAllProducts(withFixedUnits);

        // 3. Filtramos por subcategoría (si no es 'todo')
        let filtered = withFixedUnits;
        if (subcategoriaKey && subcategoriaKey !== "todo") {
        const selectedCategorySlug = getCategorySlug(subcategoriaKey);

        filtered = withFixedUnits.filter((product) => {
            if (!product.categorias || !Array.isArray(product.categorias)) return false;

            const categorias = product.categorias.map(getCategorySlug);

            return categorias.includes(selectedCategorySlug);
        });

        }

        setProducts(filtered);
        setVisibleCount(15);
        setError(null);
    } catch (err) {
        console.error("Error al cargar muebles:", err);
        setError("Error al cargar los muebles. Intenta de nuevo más tarde.");
        setProducts([]);
        setAllProducts([]);
    } finally {
        setLoading(false);
    }
};

const handleSearch = (term) => {
    setVisibleCount(15);
    setSearchParams((prev) => {
        const newParams = new URLSearchParams(prev);
        if (term) {
            newParams.set("q", term);
        } else {
            newParams.delete("q");
        }
        return newParams;
    });
};


const visibleProducts = useMemo(() => {
    if (!searchTerm) return products;
    const base = allGlobal ?? allProducts; 
    return searchByKeywords(base, searchTerm, [
        "nombreBook",
        "referencia",
        "nombreFamilia",
    ]);
}, [searchTerm, products, allProducts, allGlobal]);

    

    if (loading)
        return (
            <div className="muebles-pages__error-message">
                Cargando muebles...
            </div>
        );

    return (
        <div className="dotaciones-fijas">
            <SectionHeader
                title={`Dotaciones fijas por tienda - ${
                    subcategoriaTitle
                }`}
            />

            <div className="dotaciones-fijas__header">
                <InputSearch
                    context="tableSearch"
                    value={searchTerm}
                    onSearch={handleSearch}
                    placeholder="Buscar productos..."
                />
            </div>

            {error && (
                <div className="muebles-pages__error-message">{error}</div>
            )}

            <div className="dotaciones-fijas__cards">
                {visibleProducts.length > 0 ? (
                    <>
                        {visibleProducts
                            .slice(0, visibleCount)
                            .map((product) => (
                                <Card
                                    key={product.codMueble}
                                    title={product.nombreBook}
                                    subtitle={product.nombreFamilia}
                                    reference={product.referencia}
                                    codCategoria={
                                        product.categorias &&
                                        product.categorias.length > 0
                                            ? formatCategories(product.categorias)
                                            : null
                                    }
                                    image={product.rutaImagen}
                                    link={`/ficha-producto/${product.codMueble}`}
                                    pendienteAprobacion={
                                        product.pendienteDeAprobacion
                                    }
                                    showButton={true}
                                    dotacionesCount={product.unidadesFijas || 0}
                                    comentarios={
                                        product.descripcionUnidadesFijas
                                    }
                                />
                            ))}

                        {visibleCount < visibleProducts.length && (
                            <div className="mobiliario-central__load-more-container">
                                <Button
                                    label="Cargar más"
                                    variant="filled"
                                    icon={<IoReloadOutline />}
                                    onClick={() =>
                                        setVisibleCount((prev) => prev + 15)
                                    }
                                />
                            </div>
                        )}
                    </>
                ) : (
                    !error && (
                        <p className="dotaciones-fijas__cards__no-results-message">
                            {searchTerm
                                ? "No hay resultados para tu búsqueda"
                                : "No hay muebles con dotaciones fijas en esta categoría"}
                        </p>
                    )
                )}
            </div>
        </div>
    );
}
